import yup from 'utils/yup';

export const initialCommuterMileageData = {
  daily_mileage_cap: '' as any,
  mileage_exemption: '' as any,
};

export const commuterMileageValidation = yup.object().shape({
  daily_mileage_cap: yup.number().required(),
  mileage_exemption: yup.string().required(),
});
